<template>
	<div class="app-notification mr-5" @click.stop>
		<div v-if="showIconBell" class="cursor-pointer" @click="showLightBox = !showLightBox">
			<span v-if="isMobile">Notifications</span> 
			<div
				class="ml-2 notification-badge-icon badge badge-pill badge-danger fs-10 font-weight-normal"
			>
				{{ unreadNotificationCount }}
			</div>
			<div v-if="!isMobile" class="ml-n4 ml-lg-0 mt-lg-n2">
				<svg
					width="18"
					height="21"
					viewBox="0 0 18 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					style="position: relative; top: 5px; z-index: 0"
				>
					<path
						d="M8.99889 0.996094C13.0488 0.996094 16.3556 4.19084 16.4947 8.24515L16.4989 8.49609V12.5931L17.8789 15.7491C17.9479 15.907 17.9836 16.0775 17.9836 16.2499C17.9836 16.9402 17.424 17.4999 16.7336 17.4999L11.9989 17.5014C11.9989 19.1582 10.6557 20.5014 8.99889 20.5014C7.40121 20.5014 6.09523 19.2524 6.00398 17.6776L5.99844 17.4991L1.27375 17.4999C1.10242 17.4999 0.932907 17.4646 0.775753 17.3964C0.142551 17.1213 -0.147798 16.3851 0.127241 15.7519L1.49889 12.594V8.49599C1.49949 4.3412 4.85098 0.996094 8.99889 0.996094ZM10.4984 17.4991L7.49889 17.5014C7.49889 18.3298 8.17046 19.0014 8.99889 19.0014C9.77859 19.0014 10.4193 18.4065 10.492 17.6458L10.4984 17.4991ZM8.99889 2.49609C5.67873 2.49609 2.99937 5.17035 2.99889 8.49609V12.9057L1.65491 15.9999H16.3514L14.9989 12.9067L14.999 8.50895L14.9953 8.28375C14.8842 5.05027 12.2405 2.49609 8.99889 2.49609Z"
						fill="#777777"
					/>
				</svg>
			</div>
		</div>
		<SidePanelModal 
			title="Notifications"
			:class="{modalSize: isMobile }"  
			:showModal="showLightBox"
			:sidePanelSize="isMobile ? 'sm' : 'md'"
			@lightbox:close="showLightBox = false"
		>
		  <div v-if="unreadNotification.length" class="d-flex flex-column p-3">
			<div class="w-100 text-right mt-n3 mb-3">
				<SfeButton		  
					role="button"
					@click.stop="markAllNotificationsAsRead"
					class="app-notification__mark-all-as-read"
				>
					Mark all as read
				</SfeButton>
			</div>
		  	<div
		  		v-for="(notification, index) in unreadNotification"
		  		:key="notification.id"
				@click.stop="viewNotification(notification)"
		  	>
		  		<div
				  style="text-overflow: ellipsis; overflow:hidden; white-space:nowrap; width: 380px"
				>
					<pop-over class="d-inline-block" :content="notification.title">
						<a v-if="notification.link"
						:href="notification.link"
						:id="`notification_link_id-${index}`"
						target="_blank" 
						class="text-primary cursor-pointer"
						>
						{{notification.title}}
						</a>
						<p v-else class="mb-0 text-primary cursor-pointer">
							{{notification.title}}
						</p>
					</pop-over>
		  		</div>
		  		<div class="text-secondary fs-12 text-left mb-n3">
		  			{{ $moment(notification.created_at).fromNow() }}
		  		</div>
		  		<SfeDivider class="my-4"/>		
		  	</div>
		  </div>
		  <div v-else class="text-center p-3">
		  	<div class="mb-n3 text-muted">{{ emptyStateMessage }}</div>
		  	<div class="material-icons text-light notification-icon">insert_comment</div>
		  </div>
		</SidePanelModal>
	</div>
</template>

<script>
import NotificationModel from "../models/NotificationModel"

export default {
	name: "AppNotification",
	mixins: [NotificationModel],
	emits: ['notification-count'],
	props: {
		user: {
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
			default: false
		},
		showIconBell: {
			type: Boolean,
			default: true
		},

		displayLightBox: {
			type: Boolean,
			default: false
		},
		emptyStateMessage: {
			type: String,
			default: 'You have no pending notification'
		}
	},
	data() {
		return {
			unreadNotification: [],
			sound: '/sound/notification-sound.mp3',
			showLightBox: false
		}
	},
	computed: {
		unreadNotificationCount() {
			return this.unreadNotification.length > 9
				? "9+"
				: this.unreadNotification.length
		},
	},
	methods: {
		playSound(){
			let audio = new Audio(this.sound)
			audio.play()
		},
		getNotifications() {
			this.NotificationModel.getNotifications().then((res) => {	
				this.unreadNotification = res?.data.filter(({ title, link}) => {
					return (!!title || !!link)
				})
			})
		},
		markAllNotificationsAsRead() {
			this.NotificationModel.markAllNotificationsAsRead()
				.then(() => {
					this.unreadNotification = []
				})
		},
		viewNotification(notification) {
			this.showLightBox = false
			this.NotificationModel.markAsReadNotification({
				id: notification.id,
			}).then(() => {
				this.unreadNotification.splice(notification, 1);
			})		
		}
	},
	watch:{
		unreadNotificationCount(value){
			this.$emit('notification-count', value)
		},
		displayLightBox(newValue){
			if(newValue) {
				this.showLightBox = true;
			}
		}
	},
	mounted() {
		this.getNotifications()
	},
}
</script>
<style scoped lang="scss">
	.notification-badge-icon {
		position: absolute !important;
		z-index: 999 !important;
	}
	.notification-icon{
		font-size: 20em;
	}

	::v-deep .modalSize  .light-box-content {
		width: 100% !important
	}

	.app-notification {
		&__mark-all-as-read {
			border: none;
			background-color: transparent;
			cursor: pointer;
			color: #296DB3;
			margin-left: auto;
			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>